// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/library.js';

import { paths } from '../generated/library';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('library', Original, paths);
